import React, { ChangeEvent, useId } from "react";
import type {
  CheckboxesQuestion,
  CheckboxesResponse,
} from "@r6digital/rapidstor-types/types/Questionnaire";
import Form from "react-bootstrap/Form";
import classes from "./Question.module.scss";

interface Props {
  question: CheckboxesQuestion;
  response: CheckboxesResponse;
  checked?: boolean;
  onChange?: (answer: string | boolean | number, checked: boolean) => void;
}

function CheckboxesResponse({ response, checked = false, onChange }: Props) {
  const id = useId();

  const onChangeEvent = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(response.answer, event.currentTarget.checked);
    }
  };

  return (
    <div className={`mb-2 ${classes.response}`}>
      <Form.Check
        id={id}
        type={"checkbox"}
        label={response.answer}
        value={response.answer}
        checked={checked}
        onChange={onChangeEvent}
      />
    </div>
  );
}

export default CheckboxesResponse;
